import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../Header';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Control, LocalForm } from 'react-redux-form';
import { Helmet } from 'react-helmet';
import Alert from '../../container/Alert';
import Comfirm from '../../container/Comfirm';
import Footer from '../Footer';

const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'user.download.label.name',
    description: 'Page Header Title',
    defaultMessage: 'User Download'
  },
  headerSubTitle: {
    id: 'download.page.title',
    description: 'Page Header Subtitle',
    defaultMessage: 'Download'
  },
  searchFiles: {
    id: 'preview.search.files',
    description: 'search files',
    defaultMessage: 'Search Files'
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});

const print = status => {
  if (status.payload) {
    // console.log(status.payload.response);
    return status.payload.response;
  }
};

const Download = props => (
  <div className="preview page">
    <Helmet>
      <title>{props.intl.formatMessage(messages.htmlHeader)} - SHIFT</title>
    </Helmet>
    <Header
      title={props.intl.formatMessage(messages.headerTitle)}
      subtitle={props.intl.formatMessage(messages.headerSubTitle)}
      icon="preview"
      locale={props.locale}
    />

    <Alert
      title="Approve Account Error"
      body="Invalid Username"
      message={print(props.status)}
    />
    <Comfirm
      pagetitle={props.intl.formatMessage(messages.htmlHeader)}
      message={print(props.status)}
      nextpage="approvemsg"
    />

    <div className="main">
      <div
        className="panel"
        style={{
          width: '60%',
          padding: '40px',
          boxSizing: 'content-box',
          marginTop: '15px',
          display: 'block',
          alignContent: 'center',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}
      >
        <LocalForm
          onSubmit={({ role }) => props.approveSubmitHandler(role)}
          className="form"
        >
          <div className="form">
            <label
              style={{
                width: '90%',
                fontSize: '16px',
                lineHeight: '150%',
                textTransform: 'capitalize',
                textAlign: 'center'
              }}
            >
              Analyzer Report
              <br />
              Request for qotation
            </label>

            <br />
            <br />
          </div>

          <fieldset>
            <label style={{ textTransform: 'capitalize' }}>
              <FormattedMessage
                id="edit-project.form.name"
                id="translationapproval.reference.id"
                defaultMessage="reference: "
              />
            </label>
            <Control.text
              model=".name"
              defaultValue={props.membername}
              disabled
              autoFocus
              required
            />
          </fieldset>

          <p style={{ marginTop: '150px' }}></p>

          <div className="button-container" style={{ textAlign: 'center' }}>
            <button
              className="button"
              type="submit"
              style={{ marginRight: '40px' }}
              onClick={() => props.downloadHandler()}
            >
              <FormattedMessage
                id="download.page.title"
                textTransform="capitalize"
                defaultMessage="Download"
              />
            </button>

            <button
              className="button"
              type="button"
              onClick={() => props.clickOKHandler()}
            >
              <FormattedMessage id="nav.ok" defaultMessage="OK" />
            </button>
          </div>
        </LocalForm>
      </div>
    </div>
    <Footer />
  </div>
);

Download.propTypes = {
  locale: PropTypes.string,
  intl: PropTypes.object,
  status: PropTypes.object
};

export default injectIntl(Download);



// WEBPACK FOOTER //
// ./src/components/views/Download/index.js